import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {ActionLink, Panel} from 'shared/components';

const EmployeeAttribute = observer(({label, value, translateLabel = true}) => {
  return (
    <div className='flex'>
      <div className='col-6 mr1'>
        {translateLabel ? <FormattedMessage id={label} /> : label}
      </div>
      <div className='col-6'>
        {value ? value : <span className='waterloo'>{'——'}</span>}
      </div>
    </div>
  );
});

const InfoPanel = observer(({uiState, employee, canEdit, onEdit, title, attributes}) => {
  return (
    <Panel className='mb1'>
      <Panel.Header title={title}>
        {canEdit &&
          <ActionLink onClick={onEdit}>
            <FormattedMessage id='employees.profile.personal.Edit' />
          </ActionLink>}
      </Panel.Header>
      <div className='mt1 space-y'>
        {attributes.map(({label, render, translateLabel}) => {
          return <EmployeeAttribute key={label} label={label} value={render({employee, uiState})} translateLabel={translateLabel} />;
        })}
      </div>
    </Panel>
  );
});

export default InfoPanel;
